import React from 'react';
import { AnimationCard } from './components/AnimationCard';
// import { ControlConfig } from './components/DebugControls';
import SimpleBlurText from './animations/SimpleBlurText';
import SimpleGradientText from './animations/SimpleGradientText';
import SimpleShinyText from './animations/SimpleShinyText';
import SimpleCircularText from './animations/SimpleCircularText';
import SimpleFuzzyText from './animations/SimpleFuzzyText';
import SimpleSplitText from './animations/SimpleSplitText';

// Animation configurations
const animations = [
  {
    title: 'Blur Text',
    description: 'Text appears with a blur-to-sharp transition effect using Framer Motion',
    component: SimpleBlurText,
    demoClass: 'blur-text-demo',
    defaultProps: {
      text: 'BLUR ANIMATION',
      delay: 80,
      animateBy: 'letters',
      direction: 'top'
    },
    // controls: [
    //   { type: 'input', label: 'Text', key: 'text', defaultValue: 'BLUR ANIMATION' },
    //   { type: 'slider', label: 'Delay (ms)', key: 'delay', min: 0, max: 1000, step: 25, defaultValue: 150 },
    //   { type: 'select', label: 'Animate By', key: 'animateBy', options: ['words', 'letters'], defaultValue: 'words' },
    //   { type: 'select', label: 'Direction', key: 'direction', options: ['top', 'bottom'], defaultValue: 'top' },
    //   { type: 'slider', label: 'Step Duration', key: 'stepDuration', min: 0.1, max: 2, step: 0.1, defaultValue: 0.35 },
    //   { type: 'slider', label: 'Threshold', key: 'threshold', min: 0, max: 1, step: 0.1, defaultValue: 0.1 }
    // ] as ControlConfig[]
  },
  {
    title: 'Gradient Text',
    description: 'Text with animated gradient colors',
    component: SimpleGradientText,
    demoClass: 'gradient-text-demo',
    defaultProps: {
      children: 'GRADIENT TEXT',
      animationSpeed: 6,
      showBorder: false
    },
    // controls: [
    //   { type: 'input', label: 'Text', key: 'children', defaultValue: 'GRADIENT TEXT' },
    //   { type: 'slider', label: 'Animation Speed', key: 'animationSpeed', min: 1, max: 20, step: 1, defaultValue: 6 },
    //   { type: 'checkbox', label: 'Show Border', key: 'showBorder', defaultValue: false },
    //   { type: 'input', label: 'Colors (comma separated)', key: 'colorsString', defaultValue: '#40ffaa,#4079ff,#40ffaa,#4079ff,#40ffaa' }
    // ] as ControlConfig[]
  },
  {
    title: 'Shiny Text',
    description: 'Text with a traveling shine effect animation',
    component: SimpleShinyText,
    demoClass: 'shiny-text-demo',
    defaultProps: {
      text: 'SHINY TEXT',
      speed: 2.5,
      disabled: false
    },
    // controls: [
    //   { type: 'input', label: 'Text', key: 'text', defaultValue: 'SHINY TEXT' },
    //   { type: 'slider', label: 'Speed', key: 'speed', min: 1, max: 20, step: 1, defaultValue: 4 },
    //   { type: 'checkbox', label: 'Disabled', key: 'disabled', defaultValue: false }
    // ] as ControlConfig[]
  },
  {
    title: 'Circular Text',
    description: 'Text rotates in a circular path with interactive hover effects',
    component: SimpleCircularText,
    demoClass: 'circular-text-demo',
    defaultProps: {
      text: 'CIRCULAR•TEXT•ANIMATION•',
      spinDuration: 15,
      onHover: 'speedUp'
    },
    // controls: [
    //   { type: 'input', label: 'Text', key: 'text', defaultValue: 'CIRCULAR•TEXT•ANIMATION•' },
    //   { type: 'slider', label: 'Spin Duration', key: 'spinDuration', min: 5, max: 60, step: 1, defaultValue: 15 },
    //   { type: 'select', label: 'On Hover', key: 'onHover', options: ['speedUp', 'slowDown', 'pause', 'goBonkers'], defaultValue: 'speedUp' }
    // ] as ControlConfig[]
  },
  {
    title: 'Fuzzy Text',
    description: 'Text with animated noise/glitch effect using Canvas 2D',
    component: SimpleFuzzyText,
    demoClass: 'fuzzy-text-demo',
    defaultProps: {
      children: 'FUZZY TEXT',
      fontSize: 'clamp(1.5rem, 5vw, 4rem)',
      fontWeight: 900,
      fontFamily: 'inherit',
      color: '#fff',
      enableHover: true,
      baseIntensity: 0.2,
      hoverIntensity: 0.6
    },
    // controls: [
    //   { type: 'input', label: 'Text', key: 'children', defaultValue: 'FUZZY TEXT' },
    //   { type: 'input', label: 'Font Size', key: 'fontSize', defaultValue: '4rem' },
    //   { type: 'slider', label: 'Font Weight', key: 'fontWeight', min: 100, max: 900, step: 100, defaultValue: 900 },
    //   { type: 'input', label: 'Font Family', key: 'fontFamily', defaultValue: 'inherit' },
    //   { type: 'color', label: 'Color', key: 'color', defaultValue: '#fff' },
    //   { type: 'checkbox', label: 'Enable Hover', key: 'enableHover', defaultValue: true },
    //   { type: 'slider', label: 'Base Intensity', key: 'baseIntensity', min: 0, max: 1, step: 0.01, defaultValue: 0.2 },
    //   { type: 'slider', label: 'Hover Intensity', key: 'hoverIntensity', min: 0, max: 1, step: 0.01, defaultValue: 0.6 }
    // ] as ControlConfig[]
  },
  {
    title: 'Split Text',
    description: 'Text animation with character or word splitting using Framer Motion',
    component: SimpleSplitText,
    demoClass: 'split-text-demo',
    defaultProps: {
      text: 'SPLIT ANIMATION',
      delay: 80,
      duration: 0.5,
      splitType: 'chars',
      textAlign: 'center'
    },
    // controls: [
    //   { type: 'input', label: 'Text', key: 'text', defaultValue: 'SPLIT ANIMATION' },
    //   { type: 'slider', label: 'Delay (ms)', key: 'delay', min: 0, max: 500, step: 25, defaultValue: 80 },
    //   { type: 'slider', label: 'Duration', key: 'duration', min: 0.1, max: 2, step: 0.1, defaultValue: 0.5 },
    //   { type: 'select', label: 'Split Type', key: 'splitType', options: ['chars', 'words', 'lines'], defaultValue: 'chars' },
    //   { type: 'select', label: 'Text Align', key: 'textAlign', options: ['left', 'center', 'right'], defaultValue: 'center' },
    //   { type: 'select', label: 'Ease', key: 'ease', options: ['power3.out', 'power2.out', 'easeOut'], defaultValue: 'power3.out' },
    //   { type: 'slider', label: 'Threshold', key: 'threshold', min: 0, max: 1, step: 0.1, defaultValue: 0.1 }
    // ] as ControlConfig[]
  }
];

function App() {
  return (
    <div className="App">
      <div className="container">
        <header className="header">
          <h1>ANIMATIONS</h1>
        </header>

        <div className="grid">
          {animations.map((animation, index) => (
            <AnimationCard
              key={index}
              title={animation.title}
              description={animation.description}
              component={animation.component}
              // controls={animation.controls}
              defaultProps={animation.defaultProps}
              demoClass={animation.demoClass}
            />
          ))}
        </div>
      </div>
    </div>
  );
}

export default App;
